document.addEventListener('DOMContentLoaded', initColorSuggest);
document.addEventListener('cart:updated', initColorSuggest);

function initColorSuggest() {
  document.querySelectorAll('.color-suggest').forEach(input => {

    if (input.dataset.init === '1') return;

    const list = input.dataset.list;
    if (!list) return;

    new Awesomplete(input, {
      list: list.split(','),
      minChars: 1,
      maxItems: 8,
      autoFirst: true
    });

    input.dataset.init = '1';
  });
}
